import React from 'react'

export default function MenuItem({ children, item, depth = 0 }) {
    return (
        <li key={item.id} data-depth={depth}>
            <a href={item.uri} className={item?.isCurrentPage ? 'active' : ''}>
                {item.title}
            </a>
            {children}
        </li>
    )
}
